/**
 * Day 別セクション定義
 *
 * backend `src/preprocessing/section_constants.py` の SECTION_ID_TO_BLOCK_NAME と
 * SECTION_ORDER に完全一致させること。順序ずれ・名称ずれは LLM 評価ミスマッチに直結する。
 *
 * Day1: 7 セクション（既存）
 * Day2: 8 セクション（既存）
 * Day3: No.8補足シート準拠（4STEPインストール + 4STEP反復運用）
 * DayX: No.8補足シート準拠（アセスメント/完了 + 4STEP反復運用）
 */

import type { SectionDefinition } from './types';

export const DAY1_SECTIONS: SectionDefinition[] = [
  { id: 'promise',          name: 'お約束',          bgColor: 'bg-blue-50',   borderColor: 'border-l-blue-400',   textColor: 'text-blue-700',   order: 1 },
  { id: 'expectation',      name: '期待',            bgColor: 'bg-green-50',  borderColor: 'border-l-green-400',  textColor: 'text-green-700',  order: 2 },
  { id: 'achievement',      name: '達成',            bgColor: 'bg-yellow-50', borderColor: 'border-l-yellow-500', textColor: 'text-yellow-700', order: 3 },
  { id: 'problem',          name: '問題・懸念',       bgColor: 'bg-red-50',    borderColor: 'border-l-red-400',    textColor: 'text-red-700',    order: 4 },
  { id: 'strategic_focus',  name: '戦略的フォーカス',  bgColor: 'bg-purple-50', borderColor: 'border-l-purple-400', textColor: 'text-purple-700', order: 5 },
  { id: 'baumkuchen',       name: 'バームクーヘン',    bgColor: 'bg-orange-50', borderColor: 'border-l-orange-400', textColor: 'text-orange-700', order: 6 },
  { id: 'commitment',       name: 'コミットメント',    bgColor: 'bg-teal-50',   borderColor: 'border-l-teal-400',   textColor: 'text-teal-700',   order: 7 },
];

export const DAY2_SECTIONS: SectionDefinition[] = [
  { id: 'expectation',     name: '期待',                bgColor: 'bg-green-50',  borderColor: 'border-l-green-400',  textColor: 'text-green-700',  order: 1 },
  { id: 'achievement',     name: '達成',                bgColor: 'bg-yellow-50', borderColor: 'border-l-yellow-500', textColor: 'text-yellow-700', order: 2 },
  { id: 'day1_review',     name: 'Day1の確認',          bgColor: 'bg-slate-50',  borderColor: 'border-l-slate-400',  textColor: 'text-slate-700',  order: 3 },
  { id: 'pmo_intro',       name: 'PMO任命・5ケ条合意', bgColor: 'bg-indigo-50', borderColor: 'border-l-indigo-400', textColor: 'text-indigo-700', order: 4 },
  { id: 'progress_rules',  name: '進捗会議ルール説明', bgColor: 'bg-purple-50', borderColor: 'border-l-purple-400', textColor: 'text-purple-700', order: 5 },
  { id: 'progress_live',   name: '進捗会議（初回実施）', bgColor: 'bg-pink-50',   borderColor: 'border-l-pink-400',   textColor: 'text-pink-700',   order: 6 },
  { id: 'schedule_lock',   name: '今後の日程決定',     bgColor: 'bg-orange-50', borderColor: 'border-l-orange-400', textColor: 'text-orange-700', order: 7 },
  { id: 'closing',         name: '今日の成果',          bgColor: 'bg-teal-50',   borderColor: 'border-l-teal-400',   textColor: 'text-teal-700',   order: 8 },
];

export const DAY3_SECTIONS: SectionDefinition[] = [
  { id: 'expectation',     name: '期待',                                                   bgColor: 'bg-green-50',  borderColor: 'border-l-green-400',  textColor: 'text-green-700',  order: 1 },
  { id: 'achievement',     name: '達成',                                                   bgColor: 'bg-yellow-50', borderColor: 'border-l-yellow-500', textColor: 'text-yellow-700', order: 2 },
  { id: 'assessment',      name: 'アセスメント',                                           bgColor: 'bg-slate-50',  borderColor: 'border-l-slate-400',  textColor: 'text-slate-700',  order: 3 },
  { id: 'day3_install',    name: '4STEPインストール(問い整形/事実と解釈/解決策発散)',       bgColor: 'bg-cyan-50',   borderColor: 'border-l-cyan-400',   textColor: 'text-cyan-700',   order: 4 },
  { id: 'loop_operation',  name: '4STEP反復運用',                                          bgColor: 'bg-purple-50', borderColor: 'border-l-purple-400', textColor: 'text-purple-700', order: 5 },
  { id: 'closing',         name: '今日の成果',                                             bgColor: 'bg-teal-50',   borderColor: 'border-l-teal-400',   textColor: 'text-teal-700',   order: 6 },
];

export const DAY4_SECTIONS: SectionDefinition[] = [
  { id: 'expectation',            name: '期待',             bgColor: 'bg-green-50',  borderColor: 'border-l-green-400',  textColor: 'text-green-700',  order: 1 },
  { id: 'achievement',            name: '達成',             bgColor: 'bg-yellow-50', borderColor: 'border-l-yellow-500', textColor: 'text-yellow-700', order: 2 },
  { id: 'assessment_completion',  name: 'アセスメント/完了', bgColor: 'bg-slate-50',  borderColor: 'border-l-slate-400',  textColor: 'text-slate-700',  order: 3 },
  { id: 'loop_operation',         name: '4STEP反復運用',     bgColor: 'bg-cyan-50',   borderColor: 'border-l-cyan-400',   textColor: 'text-cyan-700',   order: 4, allowMultipleRanges: true },
  { id: 'closing',                name: '今日の成果',        bgColor: 'bg-teal-50',   borderColor: 'border-l-teal-400',   textColor: 'text-teal-700',   order: 5 },
];

export const NO_SECTION_MEETING_SECTIONS: SectionDefinition[] = [];

/**
 * 後方互換用。現行の No.8補足シートでは DayX の 4STEP反復運用は単一セクション。
 */
export function expandDay4Sections(_loopCount: number): SectionDefinition[] {
  void _loopCount;
  return DAY4_SECTIONS;
}

/**
 * Day 文字列を正規化して該当の SectionDefinition[] を返す。
 * "Day1"/"day1"/"DAY1" は同一視。"DayX" は Day4 として扱う。
 * 未知の Day は Day1 をフォールバック。
 */
export function getSectionsForDay(day?: string | null): SectionDefinition[] {
  if (!day) return DAY1_SECTIONS;
  const normalized = day.trim().toLowerCase();
  switch (normalized) {
    case 'day1':
      return DAY1_SECTIONS;
    case 'day2':
      return DAY2_SECTIONS;
    case 'day3':
      return DAY3_SECTIONS;
    case 'day4':
    case 'dayx':
    case 'day_x':
      return DAY4_SECTIONS;
    case 'progressmtg':
    case 'progress_mtg':
    case 'progress-mtg':
    case 'premtg':
    case 'pre_mtg':
    case 'pre-mtg':
    case 'postmtg':
    case 'post_mtg':
    case 'post-mtg':
      return NO_SECTION_MEETING_SECTIONS;
    default:
      return DAY1_SECTIONS;
  }
}
